import { Component, EventEmitter, Input, Output, OnInit, HostListener } from '@angular/core';

@Component({
    selector: 'app-spell-check-suggestion',
    templateUrl: './spell-check-suggestion.component.html',
    styleUrls: ['./spell-check-suggestion.component.scss'],
    standalone: false
})
export class SpellCheckSuggestionComponent implements OnInit {
  @Input() suggestions: string[] = [];
  @Input() originalWord: string = '';
  @Output() suggestionSelected = new EventEmitter<string>();
  @Output() closed = new EventEmitter<void>();

  showAddToDictionary: boolean = true;

  ngOnInit(): void {
    // Component initialization
  }

  /**
   * Handle suggestion selection
   */
  selectSuggestion(event: Event, suggestion: string): void {
    // Prevent the click from bubbling to the input field
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    this.suggestionSelected.emit(suggestion);
  }

  /**
   * Add word to dictionary and close
   */
  addToDictionary(): void {
    // This would typically call the spell check service to add to custom dictionary
    this.closed.emit();
  }

  /**
   * Ignore this suggestion
   */
  ignore(): void {
    this.closed.emit();
  }

  /**
   * Close the suggestion popover
   */
  close(): void {
    this.closed.emit();
  }

  /**
   * Prevent clicks inside from closing the popover
   */
  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.stopPropagation();
  }

  /**
   * Close on Escape key
   */
  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.close();
  }
}
